let io: IntersectionObserver | undefined;
const keepObserving = new WeakMap<Element, (element: Element) => boolean>();

const release = (element: Element) => {
  io?.unobserve(element);
  keepObserving.delete(element);
  element.removeAttribute("near-viewport");
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const observeNearViewport = (
  element: Element,
  keep?: (element: Element) => boolean,
): (() => void) => {
  io ??= new IntersectionObserver(
    (entries) => {
      for (const { target, isIntersecting } of entries) {
        if (keepObserving.get(target)?.(target) === false) release(target);
        else target.toggleAttribute("near-viewport", isIntersecting);
      }
    },
    { rootMargin: "200px" },
  );
  if (keep) keepObserving.set(element, keep);
  io.observe(element);

  return () => release(element);
};
